import Swal from "sweetalert2";

export const swalHomemover = Swal.mixin({
    customClass: {
        confirmButton: 'dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text homemover-gradient-button homemover-swal-button',
        cancelButton: 'dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text homemover-grey-button homemover-swal-button',
        icon: 'homemover-swal-icon',
        actions: 'homemover-swal-button-container',
        closeButton: 'homemover-swal-close-button',
        container: 'homemover-swal-container',
        popup: 'homemover-swal-popup',
        htmlContainer: 'homemover-swal-html-container'
    },
    buttonsStyling: false,
    reverseButtons: true
});